import { takeLatest, put, select, call } from 'redux-saga/effects';
import { message } from 'antd';
import isEqual from 'lodash/isEqual';
import { getDefaultStore } from 'jotai';
import { persistenceAtom } from '@components/ActionToolbar/atoms';
import { post } from '@api/sharing';
import { autoRequest } from '@api/createRequestStore';
import * as actions from './actions';
import * as types from './types';
import selector from './selectors';

function* initRequest() {
  yield put(actions.initRequest());
}

function* fetching({ config }) {
  const atomState = getDefaultStore().get(persistenceAtom);
  const enrichedConfig = {
    ...config,
    state: {
      ...config.state,
      atomState,
    },
  };

  const sharingStore = yield select(selector);
  const { payload: prevConfig, response } = sharingStore;
  if (isEqual(enrichedConfig, prevConfig) && response) {
    return;
  }

  yield put(actions.fetching());

  try {
    yield autoRequest(post, types.SCOPE, enrichedConfig);
  } catch (error) {
    yield call(message.error, error.message || 'Unknown error.');
    throw error;
  }
}

function* watchInitRequest() {
  yield takeLatest([types.INIT], initRequest);
}

function* watchFetching() {
  yield takeLatest([types.START_SHARE], fetching);
}

export default [watchInitRequest, watchFetching];
